import React, { useEffect } from "react";
import { NAV } from "constants/scheduling";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";
import { withRouter } from "react-router-dom";
import Switch from "react-switch";

import { render } from "@testing-library/react";
import connect from "react-redux/lib/connect/connect";
import * as UserDucks from "ducks/accounts/user";
const { REACT_APP_SCHEDULING_BASE_URL } = process.env;


class ShiftManagementPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { refresh: false };
    this.postMessageToChild = this.postMessageToChild.bind(this);
    const searchParams = new URLSearchParams(this.props.location.search);
    const routeView = searchParams.get("route") === "true";

   this.state = {
    useAlternativeView: routeView,
    iframeKey: Date.now(),
    oAuthToken: StorageGateway.get("oAuthToken"),
    company_id: StorageGateway.get("company_id") || StorageGateway.get("nre_company_id")
  };

  console.log("auth token",this.state);
  

    this.handleToggleChange = this.handleToggleChange.bind(this);
  }

 
  postMessageToChild(messageType) {
    const iFrame = document.getElementById("scheduling");
    iFrame.contentWindow.postMessage(messageType, "*");
  }
  componentDidMount() {
    window.addEventListener(
      "message",
      (event) => {
        const data =
          event.data &&
          typeof event.data !== "object" &&
          JSON.parse(event.data);
        const message = data?.message;
        if (message === "SHIFT_DASHBOARD_PAGE") {
          this.props.history.push(`/scheduling/dashboard`);
        }
      },
      false
    );
  }
  handleToggleChange() {
    const newView = !this.state.useAlternativeView;

    // Update URL
    this.props.history.push({
      search: `?route=${newView}`,
    });

    // Force iframe remount by changing its key
    this.setState({
      useAlternativeView: newView,
      iframeKey: Date.now(),
    });
  }

  getIframeSrc() {
  const { useAlternativeView, oAuthToken, company_id } = this.state;
  console.log("this is ids", company_id,oAuthToken);
  
  return useAlternativeView
    ? `${REACT_APP_SCHEDULING_BASE_URL}/route-management/?oAuthToken=${this.state.oAuthToken}&company_id=${this.state.company_id}`
    : `${REACT_APP_SCHEDULING_BASE_URL}/shift-management/?oAuthToken=${this.state.oAuthToken}&company_id=${this.state.company_id}`;
}

  render() {
    const { companyPermissions } = this.props;

    return (
      <TwoColumnLayout
        navInfo={NAV.ShiftManagementPage}
        fetchData={() => this.postMessageToChild("REFRESH_SHIFT_MANAGEMENT")}
      >
        {companyPermissions && companyPermissions?.jobtraks && (
          <div
            style={{
              display: "flex",
              gap: "5px",
              marginRight: "10px",
              alignItems: "center",
            }}
          >
           
            
            <span>Shift</span>
            <Switch
              checked={this.state.useAlternativeView}
              onChange={this.handleToggleChange}
              uncheckedIcon={false}
              checkedIcon={false}
              height={18}
              width={36}
              onColor="#09819A"
            />
            <span>Route</span>
          </div>
        )}
        <div
          style={{
            height: "calc(100vh - 102px - 46px)",
            //height :'100vh'
          }}
        >
          <iframe
            id="scheduling"
            title="scheduling-iframe"
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ width: "100%", height: "100%" }}
            src={this.getIframeSrc()}
            // src={`${REACT_APP_SCHEDULING_BASE_URL}/shift-management/?oAuthToken=${oAuthToken}&company_id=${company_id}`}
          />
        </div>
      </TwoColumnLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  companyPermissions: UserDucks.companyPermissions(state),
});

export default withRouter(connect(mapStateToProps)(ShiftManagementPage));
